<template>
  <g-card>
    <div class="card-info-produto-repeticao">
      <g-titulo-steps
      titulo="INFORMAÇÕES DA TRANSPORTADORA"
      subtitulo=""
      :imagemEmpresa = imagemEmpresa
      />

      <div class="header-infotransportadora-conteudo espacamento-fluxos">
        <div class="transportadora-empresa">
          <div class="empresa-titulo titulo-conteudo-fluxos"> Empresa <strong class="asterisco-obrigatorio">*</strong> </div>
          <PDropDown class="input-label unidade" placeholder="TODAS" optionLabel="nome" optionValue="id"
              :options="EmpresaArray" v-model="TransportadoraViewModel.UnidadeId">
            </PDropDown>
        </div>
        <div class="transportadora-cnpj">
          <div class="cnpj-titulo titulo-conteudo-fluxos"> CNPJ <strong class="asterisco-obrigatorio">*</strong> </div>
          <PInputText placeholder="Insira o CNPJ da Transportadora" v-mask="'##.###.###/####-##'"
              v-on:blur="verificaCPNJ" v-model="TransportadoraViewModel.Cnpj">
            </PInputText>
        </div>

        <div class="transportadora-cep">
          <div class="cep-titulo titulo-conteudo-fluxos"> CEP <strong class="asterisco-obrigatorio">*</strong> </div>
          <PInputText
          v-mask="'#####-###'"
          v-model="TransportadoraViewModel.Cep"
            class="cep-input input-label"
          />
        </div>

        <div class="transportadora-nome">
          <div class="nome-titulo titulo-conteudo-fluxos"> Nome transportadora <strong class="asterisco-obrigatorio">*</strong> </div>
          <PInputText
          v-model="TransportadoraViewModel.NomeTransportadora"
            class="nome-input input-label"
          />
        </div>

        <div class="transportadora-estado">
          <div class="estado-titulo titulo-conteudo-fluxos"> Estado <strong class="asterisco-obrigatorio">*</strong> </div>
          <PDropDown class="estado-input input-label" placeholder="UF" optionValue="id" optionLabel="siglaEstado"
              :options="EstadoArray" v-model="TransportadoraViewModel.EstadoId" :filter="true" @change="buscarcidade" />
        </div>

        <div class="transportadora-cidade">
          <div class="cidade-titulo titulo-conteudo-fluxos"> Cidade <strong class="asterisco-obrigatorio">*</strong></div>
          <PDropDown class="cidade-input input-label" placeholder="Insira a cidade da Transportadora" optionValue="id"
              optionLabel="nomeCidade" :options="CidadeArray" :disabled="!TransportadoraViewModel.EstadoId" v-model="TransportadoraViewModel.CidadeId"
              @change="setCidade" @filter="buscarCidadeSemEstado($event.value)" />
        </div>

        <div class="transportadora-endereco">
          <div class="endereco-titulo titulo-conteudo-fluxos"> Endereço <strong class="asterisco-obrigatorio">*</strong></div>
          <PInputText
          v-model="TransportadoraViewModel.Endereco"
            class="endereco-input input-label"
          />
        </div>

        <div class="transportadora-bairro">
          <div class="bairro-titulo titulo-conteudo-fluxos"> Bairro <strong class="asterisco-obrigatorio">*</strong> </div>
          <PInputText
          v-model="TransportadoraViewModel.Bairro"
            class="bairro-input input-label"
          />
        </div>

        <div class="transportadora-complemento">
          <div class="complemento-titulo titulo-conteudo-fluxos"> Complemento </div>
          <PInputText
          v-model="TransportadoraViewModel.Complemento"
            class="complemento-input input-label"
          />
        </div>
      </div>

      <div class="buttons-next-back">
        <div class="button-next">
          <g-button
          tipo="amarelo"
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="valida" 
          >
            CRIAR
          </g-button>
        </div>

        <div class="button-back">
          <g-button 
          tipo="cinza" 
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="voltar" 
          >
            VOLTAR
          </g-button>
        </div>
      </div>
    </div>
  </g-card>
</template>

<script>
import GerarNovaTransportadora from "./GerarNovaTransportadora.js";
export default GerarNovaTransportadora;

</script>

<style>
.complemento-input{
  width: 1000px;
}
.espacamento-fluxos {
  margin-top:20px ;
}
.header-infotransportadora-btnEditar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media (min-width:310px) {
  .header-infotransportadora-conteudo {
  display: grid;
  grid-template-columns: minmax(4em, 1fr);
  grid-template-rows: repeat(11, auto);
  grid-column-gap: 20px;
  grid-row-gap: 14px;
}

.buttons-next-back {
  margin: 50px 20px 30px;
}
}

@media (min-width:368px) {
.header-infotransportadora-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(8, auto);
}
.transportadora-empresa {grid-area: 1 / 1 / 2 / 3;}
.transportadora-cnpj { grid-area: 2 / 1 / 3 / 3; }
.transportadora-cep { grid-area: 3 / 1 / 4 / 3; }
.transportadora-nome { grid-area: 5 / 1 / 6 / 2;}
.transportadora-cidade {  grid-area: 4 / 2 / 5 / 3; }
.transportadora-estado { grid-area: 4 / 1 / 5 / 2; }
.transportadora-endereco { grid-area: 5 / 2 / 6 / 3;  }
.transportadora-bairro { grid-area: 6 / 1 / 7 / 3; }
.transportadora-complemento { }
}

@media (min-width:400px) {
.buttons-next-back {
  margin: 50px 0 30px;
}
}

@media (min-width:600px) {
.header-infotransportadora-conteudo {
  grid-template-rows: repeat(7, auto);
}
.transportadora-empresa { grid-area: 1 / 1 / 2 / 2; }
.transportadora-cnpj { grid-area: 1 / 2 / 2 / 3; }
.transportadora-cep { grid-area: 2 / 1 / 3 / 3; }
.transportadora-nome {grid-area: 4 / 1 / 5 / 2;  }
.transportadora-cidade { grid-area: 3 / 2 / 4 / 3; }
.transportadora-estado { grid-area: 3 / 1 / 4 / 2; }
.transportadora-endereco { grid-area: 4 / 2 / 5 / 3; }
.transportadora-bairro { grid-area: 5 / 1 / 6 / 2; }
.transportadora-complemento { grid-area: 5 / 2 / 6 / 3;}
.transportadora-ramal { grid-area: 6 / 1 / 7 / 2; }
.transportadora-suframa { grid-area: 6 / 2 / 7 / 3; }
.transportadora-incentivo-fiscal {  }
}

@media (min-width:801px) {

}

@media (min-width:1025px) {
.header-infotransportadora-btnEditar { padding: 0 50px; }

.header-infotransportadora-conteudo {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
}

.transportadora-empresa { grid-area: 1 / 1 / 2 / 3; }
.transportadora-cnpj { grid-area: 1 / 3 / 2 / 5;}
.transportadora-cep { grid-area: 1 / 5 / 2 / 7; }
.transportadora-nome { grid-area: 2 / 3 / 3 / 5; }
.transportadora-cidade { grid-area: 2 / 2 / 3 / 3; }
.transportadora-estado {  grid-area: 2 / 1 / 3 / 2;}
.transportadora-endereco { grid-area: 2 / 5 / 3 / 7; }
.transportadora-bairro { grid-area: 3 / 1 / 4 / 3; }
.transportadora-complemento { grid-area: 3 / 3 / 4 / 4; width: 677px;}
.transportadora-ramal { grid-area: 3 / 4 / 4 / 5; }
.transportadora-suframa { grid-area: 3 / 5 / 4 / 7;}
.transportadora-incentivo-fiscal {  }
}

@media (min-width:1281px) {
.header-infotransportadora-btnEditar { padding: 0 130px; }
}

@media (min-width:1500px) {
.header-infotransportadora-btnEditar { padding: 0 150px; }
}
</style>